import script from "./AnimalDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimalDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./AnimalDetailPage.vue?vue&type=style&index=0&id=fe7fc3fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe7fc3fc"]])

export default __exports__